(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvixio-product-accordions"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-orvixio-tabs]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-orvixio-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-orvixio-panel]'));
    const accordions = Array.from(section.querySelectorAll('.orvixio-product-tabs__accordion'));
    const policyCards = Array.from(section.querySelectorAll('.orvixio-policy-summary__card'));
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      policyCards.forEach((card) => card.classList.add('is-visible'));
    } else {
      const policyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            policyObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      policyCards.forEach((card) => policyObserver.observe(card));
    }

    const activateTab = (tab) => {
      const nextPanel = panels.find((panel) => panel.id === tab.getAttribute('aria-controls'));
      if (tab.getAttribute('aria-selected') === 'true' || !nextPanel) return;

      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });

      if (!reduceMotion.matches) {
        nextPanel.animate(
          [
            { opacity: 0, transform: 'translateY(6px)' },
            { opacity: 1, transform: 'translateY(0)' },
          ],
          { duration: 180, easing: 'ease-out' }
        );
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('pointerenter', () => {
        if (supportsHover.matches) activateTab(tab);
      });
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });

    accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (!accordion.open) return;
        accordions.forEach((item) => {
          if (item !== accordion) item.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!window.OrvixioProductThumbnailHover) {
    window.OrvixioProductThumbnailHover = true;

    document.addEventListener('pointerover', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      const thumbnail = event.target.closest(
        '.orvixio-product-main media-gallery .slideshow-controls__thumbnail'
      );

      if (!thumbnail || thumbnail.contains(event.relatedTarget)) return;
      if (thumbnail.getAttribute('aria-selected') === 'true') return;

      const gallery = thumbnail.closest('media-gallery');
      const slideshow = gallery?.querySelector('slideshow-component');
      const thumbnails = Array.from(
        gallery?.querySelectorAll('.slideshow-controls__thumbnail') ?? []
      );
      const index = thumbnails.indexOf(thumbnail);

      if (index >= 0 && typeof slideshow?.select === 'function') {
        slideshow.select(index, event, { animate: false });
      } else {
        thumbnail.click();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
